import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import { deactivateForm } from "./supervisionScripts";
import { saveFormsySubmission } from "../services/soar";
import { openPDF } from "../../scripts/helperScripts";
import ShareModal from "./ShareModal";

function SupervisionHeader({
  label,
  data,
  canClone,
  canDelete,
  handleSave,
  pdfRef,
}) {
  const [shareOpen, setShareOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("safyInfo")).user;

  const postDeactivate = () => {
    navigate("/supervision2");
  };

  const handleClone = () => {
    const clone = {
      ContainerId: data.ContainerId,
      VersionId: data.VersionId,
      ApplicationId: data.ApplicationId,
      PrimaryObjectId: data.PrimaryObjectId,
      PrimaryObjectName: data.PrimaryObjectName,
      PrimaryObjectType: data.PrimaryObjectType,
      SecondaryObjectId: data.SecondaryObjectId,
      SecondaryObjectName: data.SecondaryObjectName,
      SecondaryObjectType: data.SecondaryObjectType,
      TertiaryObjectId: "",
      TertiaryObjectName: "",
      TertiaryObjectType: "",
      Results: data.Results,
      Related: [],
      Compliancy: "",
      ModifiedById: user.azureId,
      ModifiedByName: user.displayName,
    };

    //Form Result fields
    clone.Results.DateSupervision = "";
    clone.Results.LengthOfSupervision = "";
    clone.Results.CountsAsLicensure = false;
    clone.Results.LengthOfLicensure = "";
    clone.Results = JSON.stringify(clone.Results);

    saveFormsySubmission(clone, "Insert").then((response) => {
      if (response.data[0].code === "success") {
        navigate(
          `/supervision/${
            clone.ContainerId === "A51B13BE-6B02-EF11-8076-DC98408D5418"
              ? "individual"
              : "group"
          }/${response.data[0].id}`
        );
      }
    });
  };

  const sendToPDF = () => {
    if (pdfRef) {
      toast.warning(
        "Form being converted into PDF. This may take a little time, please do not navigate away",
        {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "colored",
        }
      );
      openPDF(pdfRef.current);
    }
  };

  return (
    <>
      {shareOpen && (
        <ShareModal
          isOpen={shareOpen}
          handleClose={() => setShareOpen(false)}
          submissionData={data}
        />
      )}
      <div className="bg-safy2-1  text-white">
        <div className="row">
          <div className="h2 px-4 pt-2">{label}</div>
          <div className="col px-4">
            {data.ModifiedOn !== undefined ? (
              <strong className="d-print-none" style={{ float: "right" }}>
                {` Last saved on
    ${moment
      .utc(data.lastModifiedOn)
      .local()
      .format("MMM D, YYYY [at] h:mm A")}`}
              </strong>
            ) : (
              <strong
                className="d-print-none text-warning d-flex"
                style={{ float: "right" }}
              >
                <i className="fas fa-exclamation-triangle mt-1 me-1"></i>
                To prevent loss of work, please click save.
              </strong>
            )}
          </div>
        </div>
        <div className="bg-safy2-1  text-white h6 ps-4 pb-2 m-0 row">
          <div className="col">Supervisee: {data.PrimaryObjectName}</div>
          <div className="col">Supervisor: {data.SecondaryObjectName}</div>
        </div>
        <div className="bg-safy3-1  p-2 clearfix d-print-none m-0">
          <div className="float-end">
            <i
              title="Save"
              role="button"
              className="far fa-save fa-2x text-white mx-1"
              onClick={() => {
                handleSave();
              }}
            ></i>
            <i
              className="fas fa-share fa-2x text-white"
              role="button"
              onClick={() => setShareOpen(true)}
            />
            {canClone && (
              <i
                title="Clone"
                role="button"
                className="far fa-clone fa-2x text-white mx-1"
                onClick={(e) => {
                  if (
                    window.confirm("Are you sure you want to clone the form?")
                  ) {
                    handleClone(e);
                  }
                }}
              ></i>
            )}
            {canDelete && (
              <i
                title="Delete"
                role="button"
                className="far fa-trash-alt fa-2x text-white mx-1"
                onClick={(e) => {
                  deactivateForm(data.SubmissionId, postDeactivate);
                }}
              ></i>
            )}
            {user.modules.includes("Admin") && (
              <i
                className="far fa-trash-alt fa-2x text-danger mx-1"
                title="Admin Delete"
                role="button"
                onClick={() =>
                  deactivateForm(data.SubmissionId, postDeactivate)
                }
              ></i>
            )}
            <i
              title="Print"
              role="button"
              className="fas fa-print fa-2x text-white mx-1"
              onClick={() => {
                sendToPDF();
              }}
            ></i>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupervisionHeader;
